export {};
//# sourceMappingURL=is-part-of-a-cycle-function.js.map